import { graphql } from '@/graphql-setup'

export const WORK_PERIOD_SEGMENTS_QUERY = graphql(`
  query WorkPeriodSegments(
    $userId: ID!
    $dateStart: DateTime!
    $dateEnd: DateTime!
  ) {
    workPeriodSegments(
      userId: $userId
      dateStart: $dateStart
      dateEnd: $dateEnd
    ) {
      datetimeStart
      datetimeEnd
    }
  }
`)

export const ALL_TIME_ADDONS = graphql(`
  query AllTimeAddons($dateStart: DateTime, $dateEnd: DateTime, $user: ID) {
    allTimeAddons(dateStart: $dateStart, dateEnd: $dateEnd, user: $user) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          overrideOtherAddons
          salaryCode {
            id
            name
            externalId
          }
          salaryCodeIfOvertime {
            id
            name
            externalId
          }
          comment
        }
      }
    }
  }
`)

export const ALL_FIXED_HOURLY_ADDONS = graphql(`
  query AllFixedHourlyAddons($user: ID, $salaryWorkTime: ID) {
    allFixedHourlyAddons(user: $user, salaryWorkTime: $salaryWorkTime) {
      edges {
        node {
          id
          salaryCode {
            id
            name
            externalId
          }
          salaryCodeIfOvertime {
            id
            name
            externalId
          }
          validFrom
          validTo
        }
      }
    }
  }
`)

export const ALL_FIXED_SALARY_ADDONS = graphql(`
  query AllFixedSalaryAddons($user: ID, $salaryWorkTime: ID) {
    allFixedSalaryAddons(user: $user, salaryWorkTime: $salaryWorkTime) {
      edges {
        node {
          id
          salaryCode {
            id
            name
            externalId
          }
          validFrom
          validTo
        }
      }
    }
  }
`)

export const ALL_FIXED_SALARY_DAY_ADDONS = graphql(`
  query AllFixedSalaryDayAddons($user: ID, $salaryWorkTime: ID) {
    allFixedSalaryDayAddons(user: $user, salaryWorkTime: $salaryWorkTime) {
      edges {
        node {
          id
          salaryCode {
            id
            name
            externalId
          }
          validFrom
          validTo
        }
      }
    }
  }
`)

export const ALL_TIME_OVERRIDES = graphql(`
  query AllTimeOverrides($dateStart: DateTime, $dateEnd: DateTime, $user: ID) {
    allTimeOverrides(dateStart: $dateStart, dateEnd: $dateEnd, user: $user) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          salaryCode {
            id
            name
            externalId
          }
          comment
        }
      }
    }
  }
`)

export const SALARY_BASES = graphql(`
  query SalaryBases {
    allSalaryBases {
      id
      name
      year
      month
      createdAt
      missingExports
      entryCount
      differenceEntryCount
      unexportedEntryCount
      unexportedDifferenceCount
    }
  }
`)

export const SALARY_BASE = graphql(`
  query SalaryBase($id: ID!) {
    salaryBase(id: $id) {
      id
      name
      year
      month
      createdAt
      missingExports
      entryCount
      differenceEntryCount
      unexportedEntryCount
      unexportedDifferenceCount
    }
  }
`)

export const SALARY_BASE_ENTRIES = graphql(`
  query SalaryBaseEntries(
    $id: ID!
    $user: ID
    $leaderGroups: [String!]
    $onlyNonExported: Boolean
    $orderBy: String
  ) {
    allSalaryBaseEntries(
      salaryBase: $id
      user: $user
      leaderGroups: $leaderGroups
      onlyNonExported: $onlyNonExported
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          user {
            id
            fullName
            internalNumber
          }
          initialAmount
          amount
          departmentId
          facilityId
          salaryId
          exportTimestamp
        }
      }
    }
  }
`)

export const DIFFERENCE_SALARY_BASE_BY_MONTH = graphql(`
  query DifferenceSalaryBaseByMonth($year: Int, $month: Int) {
    differenceSalaryBaseByMonth(year: $year, month: $month) {
      id
      name
      year
      month
    }
  }
`)

export const DIFFERENCE_SALARY_BASE_ENTRIES = graphql(`
  query DifferenceSalaryBaseEntries(
    $id: ID!
    $user: ID
    $leaderGroups: [String!]
    $onlyNonExported: Boolean
    $orderBy: String
  ) {
    allDifferenceSalaryBaseEntries(
      differenceSalaryBase: $id
      user: $user
      leaderGroups: $leaderGroups
      onlyNonExported: $onlyNonExported
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          createdAt
          user {
            id
            fullName
            internalNumber
          }
          initialAmount
          amount
          departmentId
          facilityId
          salaryId
          exportTimestamp
        }
      }
    }
  }
`)

export const ALL_FIXED_ADDONS = graphql(`
  query AllFixedAddons($dateStart: DateTime, $dateEnd: DateTime, $userId: ID) {
    allFixedAddons(user: $userId, dateStart: $dateStart, dateEnd: $dateEnd) {
      edges {
        node {
          id
          date
          amount
          salaryCode {
            id
            name
            externalId
          }
          comment
        }
      }
    }
  }
`)

export const SALARY_STATISTICS = graphql(`
  query SalaryStatistics($year: Int!, $month: Int!) {
    allUsersWithExportedSalaryBaseEntries(year: $year, month: $month) {
      id
      fullName
    }
    allUsersWithUnexportedSalaryBaseEntries(year: $year, month: $month) {
      id
      fullName
    }
    allUsersMissingSalaryBaseEntries(year: $year, month: $month) {
      id
      fullName
    }
  }
`)

export const WORK_PERIOD_MONTH_REPORT = graphql(`
  query WorkPeriodMonthReport(
    $user: ID!
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
    $year: Int!
    $month: Int!
  ) {
    monthReport(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
      year: $year
      month: $month
    ) {
      totalWorkTime
      isLocked
      lockLogs {
        id
        createdAt
        wroteDifference
        lockedBy {
          id
          fullName
        }
      }
      workPeriodGroups {
        id
        approvedByManager
        approvedByUser
        absenceDay {
          date
          absence {
            id
            reason
            absenceType {
              id
              name
              externalId
            }
          }
        }
        workPeriods {
          id
          datetimeStart
          datetimeEnd
          approvedByUser
          userComment
          approvedByManager
          managerComment
          editedAfterLock
          lockedAt
          userApprover {
            id
            fullName
          }
          managerApprover {
            id
            fullName
          }

          driverDiet {
            __typename
            id
            partOfDay
            comment
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
            generationTrace
          }
          salaryDay {
            __typename
            id
            partOfDay
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
            generationTrace
          }
          user {
            id
            fullName
            includeInSalaryCalculation
            salaryWorkTime(moduleConfigName: "Timesheets") {
              id
              pauseThreshold
              pauseDuration
              dailyWorkLimit
              salaryDateStart
              salaryDateEnd
              availableDepartments {
                id
                name
              }
              defaultDepartment {
                id
                name
              }
            }
          }
          groupedActivitySums {
            name
            id
            salaryId
            sum
          }
          groupedActivities {
            salaryId
            salaryName

            vehicleVin
            regNr
            startTime
            endTime
            timeWorkTotal

            department {
              id
              name
            }
            facility {
              id
              name
            }
          }
          activities {
            id
            activityType
            datetimeStart
            datetimeEnd
            excludeFromSalaryCalculation
            excludeBefore
            excludeAfter
            excludeComment
            duration
            manuallyEntered
          }
          estimateActivities {
            id
            activityType
            datetimeStart
            datetimeEnd
            excludeFromSalaryCalculation
            excludeBefore
            excludeAfter
            excludeComment
            duration
            manuallyEntered
          }
          salaryActivities {
            id
            activityType
            datetimeStart
            datetimeEnd
            excludeFromSalaryCalculation
            excludeBefore
            excludeAfter
            excludeComment
            duration
            manuallyEntered
          }
          timeEntries {
            id
            datetimeStart
            datetimeEnd
            totalWorkTime
            comment
          }
          salarySetting {
            id
            salaryType
            useDayOvertime
            useWeekOvertime
            usePlannerForOvertime
          }
          startLocationDetail {
            id
            description
            postalCode
            postalCity
          }
          endLocationDetail {
            id
            description
            postalCode
            postalCity
          }
          activityTimes {
            timeWorkTotal
          }
          leaderGroup {
            id
            name
          }
        }
        totalWorkTime
        overtime
        paidPause
        requiredPause
        calendarItem {
          __typename
          id
          title
          start
          end
          duration
          vehicle {
            registrationNumber
            department {
              id
              name
              externalId
            }
            facility {
              id
              name
              externalId
            }
          }
          secondaryVehicle {
            registrationNumber
          }
        }
        groupedActivitySums {
          name
          id
          sum
          negative
          salaryId
        }
        monthGroupedActivitySums {
          name
          id
          sum
          negative
          salaryId
        }
        weekSums {
          weekStart
          totalWorkTime
          groupedActivitySums {
            name
            id
            sum
            salaryId
          }
        }
        groupedActivitySumsFloat {
          name
          id
          salaryId
          sum
        }
      }
      overtime {
        name
        id
        sum
        nextMonth
      }
      undertime {
        name
        id
        sum
        nextMonth
      }
      totalWorkTimeApproved
      payrollScopedSalaryIds
      groupedActivitySumsAll {
        name
        id
        sum
        salaryId
      }
      groupedActivitySumsApproved {
        name
        id
        sum
        salaryId
      }
      groupedActivitySumsFloatAll {
        name
        id
        sum
        salaryId
      }
      groupedActivitySumsFloatApproved {
        name
        id
        sum
        salaryId
      }
      salaryCorrections {
        id
        reason
        amount
        salaryCode {
          id
          name
          externalId
        }
        department {
          id
          name
          externalId
        }
        facility {
          id
          name
          externalId
        }
        createdAt
        createdBy {
          id
          fullName
        }
      }
    }
    allSalaryComments(user: $user, year: $year, month: $month) {
      id
      value
      isGlobal
      createdBy {
        id
        fullName
      }
      createdAt
    }
    salaryBaseByMonth(year: $year, month: $month) {
      id
      name
      year
      month
      createdAt
      entriesWithoutDepartment(userId: $user) {
        id
        user {
          id
          fullName
          internalNumber
        }
        initialAmount
        amount
        departmentId
        salaryId
      }
    }
  }
`)

export const ALL_SALARY_CORRECTIONS_QUERY = graphql(`
  query SalaryCorrectionComboboxQuery {
    allSalaryCorrections {
      id
      user {
        id
        fullName
      }
      reason
      department {
        id
        name
        externalId
      }
      facility {
        id
        name
        externalId
      }
      salaryCode {
        id
        name
        externalId
      }
      amount
      createdAt
    }
  }
`)

export const WORK_PERIODS = graphql(`
  query AllWorkPeriods(
    $user: ID
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
    $withWorkTimes: Boolean! = false
    $withDepartments: Boolean! = false
    $withFacilities: Boolean! = false
  ) {
    allWorkPeriods(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          leaderGroup {
            id
            name
          }
          approvedByUser
          approvedByManager
          isEstimated
          userComment
          managerComment
          editedAfterLock
          lockedAt
          userApprover {
            id
            fullName
          }
          managerApprover {
            id
            fullName
          }
          user {
            id
            fullName
            includeInSalaryCalculation
            # Only the id is needed here — it gates the "extend day" button.
            # The department lists (needed by ExtendWorkPeriodModal) are fetched
            # on demand via EXTEND_USER_SALARY_WORK_TIME when the modal opens,
            # so the all-users approval list doesn't pull them for every row.
            salaryWorkTime(moduleConfigName: "Timesheets") {
              id
            }
          }
          hasTimeEntries
          timeEntries {
            id
            datetimeStart
            datetimeEnd
            comment
          }
          hasFerryConditions
          hasUnknownVehicle
          hasOnlyBlankVehicleDriving
          driverDiet {
            __typename
            id
            partOfDay
            comment
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
            generationTrace
          }
          salaryDay {
            __typename
            id
            partOfDay
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
            generationTrace
          }
          calendarItem {
            __typename
            id
            title
            start
            end
            numComments
            numCommentsUnread
          }
          startLocationDetail {
            id
            description
            postalCode
            postalCity
          }
          endLocationDetail {
            id
            description
            postalCode
            postalCity
          }
          addonsAsText
          # Each costs a per-row computation, so it is only asked for while its
          # column is switched on.
          activityTimes @include(if: $withWorkTimes) {
            timeWorkTotal
            timePause
          }
          departments @include(if: $withDepartments) {
            department {
              id
              name
              externalId
            }
            duration
          }
          facilities @include(if: $withFacilities) {
            facility {
              id
              name
              externalId
            }
            duration
          }
          salarySetting {
            id
            name
            salaryType
            useDayOvertime
            useWeekOvertime
            usePlannerForOvertime
          }
          absenceHourTransaction {
            id
          }
        }
      }
    }
    allCalendarItems(
      user: $user
      type: USER
      start_Lte: $datetimeEnd
      end_Gte: $datetimeStart
    ) {
      edges {
        node {
          __typename
          id
          title
          start
          end
          category
          numComments
          numCommentsUnread
          user {
            id
            fullName
            includeInSalaryCalculation
          }
          workPeriods {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`)

// Rests are only rendered for a single selected driver -- a rest is the gap
// between one driver's consecutive shifts, so it means nothing interleaved
// with other drivers' rows. Keeping it out of WORK_PERIODS also keeps the
// all-users list exactly as cheap as it is today.
export const REST_PERIODS = graphql(`
  query AllRestPeriods(
    $user: ID!
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
    $weekRestsOnly: Boolean
  ) {
    allRestPeriods(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
      weekRestsOnly: $weekRestsOnly
    ) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          restType
          isWeekRest
          workPeriodBefore {
            id
            approvedByUser
            approvedByManager
          }
          salarySetting {
            id
            name
            salaryType
          }
          driverDiet {
            __typename
            id
            partOfDay
            comment
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
            generationTrace
          }
          salaryDay {
            __typename
            id
            partOfDay
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
            generationTrace
          }
        }
      }
    }
  }
`)

// Split out of WORK_PERIODS so the "N users need approval" banner loads and
// renders independently of the (much heavier) work-period list, and only when
// the viewer can see other users.
export const REMAINING_WORK_PERIOD_RESOLVING = graphql(`
  query RemainingWorkPeriodResolving(
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
  ) {
    remainingWorkPeriodResolving(
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      user {
        id
        fullName
        includeInSalaryCalculation
      }
      numTasks
    }
  }
`)

// Fetched lazily when the "extend day" modal opens, so the approval list
// (WORK_PERIODS) no longer pulls a user's department lists for every row.
export const EXTEND_USER_SALARY_WORK_TIME = graphql(`
  query ExtendUserSalaryWorkTime($userId: ID!) {
    user(id: $userId) {
      id
      salaryWorkTime(moduleConfigName: "Timesheets") {
        id
        availableDepartments {
          id
          name
        }
        defaultDepartment {
          id
          name
        }
      }
    }
  }
`)

export const WORK_PERIODS_EDITED_AFTER_LOCK = graphql(`
  query WorkPeriodsEditedAfterLock(
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
  ) {
    workPeriodsEditedAfterLock(
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      user {
        id
        fullName
        includeInSalaryCalculation
      }
      numTasks
    }
  }
`)

export const SALARY_LOCK_RUN = graphql(`
  query SalaryLockRun($id: ID!) {
    salaryLockRun(id: $id) {
      id
      status
      progress
      totalUsers
      processedUsers
      errors {
        user
        error
      }
    }
  }
`)

export const LATEST_SALARY_LOCK_RUN = graphql(`
  query LatestSalaryLockRun($year: Int!, $month: Int!) {
    latestSalaryLockRun(year: $year, month: $month) {
      id
      status
      progress
      totalUsers
      processedUsers
      errors {
        user
        error
      }
    }
  }
`)

export const SALARY_MONTH_SUMMARY = graphql(`
  query SalaryMonthSummary(
    $user: ID!
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
  ) {
    monthReport(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      totalWorkTime
      totalWorkTimeApproved
      overtimeWithinMonth
      overtimeWithinMonthApproved
      workPeriodGroups {
        id
        workPeriods {
          id
          datetimeStart
          approvedByUser
          approvedByManager
          activityTimes {
            timeDriving
            timeOtherWork
            timeAvailability
            timePause
            timeRest
            timePaidRest
            timeWorkTotal
          }
          salarySetting {
            useDayOvertime
            useWeekOvertime
            useMonthOvertime
          }
        }
      }
    }
  }
`)

export const CALENDAR_ITEM_COMMENTS = graphql(`
  query SalaryCalendarItemComments($calendarItemId: ID!) {
    calendarItemComments(calendarItemId: $calendarItemId) {
      __typename
      id
      createdAt
      createdBy {
        __typename
        id
        fullName
        profilePicture
      }
      text
    }
  }
`)

export const WORK_PERIOD = graphql(`
  query WorkPeriod($id: ID!) {
    workPeriod(id: $id) {
      id
      datetimeStart
      datetimeEnd
      approvedByUser
      approvedByManager
      userComment
      managerComment
      absenceHourTransaction {
        id
      }
      user {
        id
        fullName
      }
      activities {
        id
        vehicleRegistrationNumber
        vehicleVin
        activityType
        datetimeStart
        datetimeEnd
      }
      activityTimes {
        timeWorkTotal
        timeDriving
        timePaidRest
        timeAvailability
        timeOtherWork
        timePause
      }
      drivenCoordinates {
        vehicleVin
        vehicleRegistrationNumber
        coordinates {
          lat
          lng
          timestamp
        }
      }
      startLocation {
        id
        totalKmDriven
        totalFuelUsed
        details {
          id
          description
        }
      }
      endLocation {
        id
        totalKmDriven
        totalFuelUsed
        details {
          id
          description
        }
      }
      driverGrade {
        id
        grade
      }
      drivingGrade
    }
  }
`)

export const WORK_PERIOD_LOGS = graphql(`
  query WorkPeriodLogs($id: ID!) {
    workPeriod(id: $id) {
      id
      datetimeStart
      datetimeEnd
      lockedAt
      actionLogs {
        id
        action
        actionFields
        createdAt
        user {
          id
          fullName
        }
      }
    }
  }
`)

export const GRAPH_WORK_PERIOD = graphql(`
  query GraphWorkPeriod($id: ID!) {
    workPeriod(id: $id) {
      id
      datetimeStart
      datetimeEnd
      approvedByUser
      approvedByManager
      userComment
      managerComment
      absenceHourTransaction {
        id
      }
      user {
        id
        fullName
      }
      activities {
        id
        activityType
        datetimeStart
        datetimeEnd
        excludeFromSalaryCalculation
        excludeBefore
        excludeAfter
        excludeComment
        duration
        manuallyEntered
      }
      estimateActivities {
        id
        activityType
        datetimeStart
        datetimeEnd
        excludeFromSalaryCalculation
        excludeBefore
        excludeAfter
        excludeComment
        duration
        manuallyEntered
      }
      ferryConditions {
        id
        type
        timestamp
      }
      timeEntries {
        id
        datetimeStart
        datetimeEnd
        totalWorkTime
        comment
      }
      activityTimes {
        timeWorkTotal
      }
      salaryActivities {
        id
        activityType
        datetimeStart
        datetimeEnd
        excludeFromSalaryCalculation
        excludeBefore
        excludeAfter
        excludeComment
        duration
        manuallyEntered
      }
      groupedActivities {
        salaryId
        salaryName

        vehicleVin
        regNr
        startTime
        endTime
        timeWorkTotal
      }
    }
  }
`)

export const CLOSEST_CALENDAR_ITEMS = graphql(`
  query ClosestCalendarItems($workPeriodId: ID!) {
    closestCalendarItemsToWorkPeriod(workPeriod: $workPeriodId) {
      id
      title
      start
      end
      workPeriods {
        edges {
          node {
            id
            datetimeStart
            datetimeEnd
          }
        }
      }
    }
  }
`)

export const ALL_SALARY_GROUPS = graphql(`
  query AllSalaryGroups {
    allSalaryGroups {
      edges {
        node {
          id
          name
          users {
            edges {
              node {
                id
                fullName
              }
            }
          }
          responsibleUsers {
            edges {
              node {
                id
                fullName
              }
            }
          }
        }
      }
    }
  }
`)

export const ALL_SALARY_GROUPS_SHALLOW_QUERY = graphql(`
  query AllSalaryGroupsShallow {
    allSalaryGroups {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)

export const USER_ADDON_KINDS_QUERY = graphql(`
  query UserAddonKinds($id: ID!) {
    user(id: $id) {
      id
      salaryWorkTime(moduleConfigName: "Activities") {
        id
        useTimeAddons
        useTimeOverrides
        useFixedAddons
      }
    }
  }
`)
